// extracted by css-extract-rspack-plugin
export default {"field":"field-aC6I4N","linkButton":"linkButton-XrIVS0","speechButton":"speechButton-zivI5C"};